import {mapApiError} from "../../shared/api/errors";

const MAX_STAFF_MESSAGE_LENGTH = 500;
const AUTHORITATIVE_STAFF_STATUSES = new Set([403, 404, 409]);

export const mapStaffApiError = (error) => {
    const mapped = mapApiError(error);
    const status = error?.response?.status;
    const backendMessage = error?.response?.data?.message;
    if (!AUTHORITATIVE_STAFF_STATUSES.has(status) || typeof backendMessage !== "string" || !backendMessage) {
        return mapped;
    }
    return {...mapped, message: backendMessage.slice(0, MAX_STAFF_MESSAGE_LENGTH)};
};
